import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CompaniesCollection, Company } from '@dges/modules/portfolio/domain';
import {
  Firestore,
  CollectionReference,
  DocumentReference,
  collection,
  collectionData,
  addDoc,
  doc,
  updateDoc,
  deleteDoc,
} from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root',
})
export class CompaniesCollectionService implements CompaniesCollection {
  private firestore = inject(Firestore);

  private companiesCollection = collection(
    this.firestore,
    'companies',
  ) as CollectionReference<Company>;

  public getCompanies(): Observable<Company[]> {
    return collectionData(this.companiesCollection, {
      idField: 'id',
    }) as Observable<Company[]>;
  }

  public addCompany(company: Company): Promise<DocumentReference<Company>> {
    return addDoc(this.companiesCollection, company);
  }

  public editCompany(company: Company): Promise<void> {
    return updateDoc(doc(this.companiesCollection, String(company.id)), {
      ...company,
    });
  }

  public deleteCompany(company: Company): Promise<void> {
    return deleteDoc(doc(this.companiesCollection, String(company.id)));
  }
}
